import { Button, Flex, Modal, Typography } from '@iheartjane/reefer';
import { sentenceCase } from '@iheartjane/utils';

import { ClientOnly } from '@jane/bloom/components/clientOnly';
import { useStoreSwitcher } from '@jane/bloom/hooks/storeSwitcher/useStoreSwitcher';

export function ReservationModeWarningModal() {
  const {
    reservationModeWarningShown,
    searchReservationMode,
    setReservationModeWarningShown,
  } = useStoreSwitcher();

  const oppositeMode =
    searchReservationMode === 'pickup' ? 'delivery' : 'pickup';

  const onRequestClose = () => setReservationModeWarningShown(false);
  return (
    <ClientOnly>
      {() => (
        <Modal
          variant="dialogue"
          onRequestClose={onRequestClose}
          open={reservationModeWarningShown}
        >
          <Modal.Content>
            <Flex width="300px" flexDirection="column" alignItems="center">
              <Typography variant="title-bold" mb={16} color="text-main">
                {sentenceCase(searchReservationMode)} Unavailable
              </Typography>

              <Typography mb={32} color="text-main">
                Your selected store does not support {searchReservationMode}.
                Please select {oppositeMode} or try a different store.
              </Typography>
            </Flex>

            <Button
              full
              variant="primary"
              label="Go back"
              onClick={onRequestClose}
            />
          </Modal.Content>
        </Modal>
      )}
    </ClientOnly>
  );
}
